import * as actionTypes from '../../../constants/actionTypes'
import IntlMessages from '../../../util/IntlMessages'
import config from '../../../util/config'
import * as db from '../../../util/db'

export const dataAction = (payload) => (dispatch) => dispatch({ type: actionTypes.DATA, payload })

export const categoryDetailsAction = (payload) => (dispatch) => dispatch({ type: actionTypes.CATEGORY_DETAILS, payload })

export const openMenuAction = (payload) => (dispatch) => dispatch({ type: actionTypes.OPEN_MENU, payload })

export const redirectAction = (payload, id = false) => (dispatch) => dispatch({ type: actionTypes.REDIRECT, payload, id })

export const backdropAction = (payload) => (dispatch) => dispatch({ type: actionTypes.LOADING_BACKDROP, payload })

export const loadingPageAction = (payload) => (dispatch) => dispatch({ type: actionTypes.LOADING_PAGE, payload })

export const snackbarAction = (status = false, message = '') =>
    (dispatch) => dispatch({ type: actionTypes.SNACKBAR, payload: { status, message } })

export const sendPushWelcomeAction = () => async (dispatch) => {
    if (db.getWelcome()) {
        dispatch(snackbarAction(true, <IntlMessages id="welcomeToDobande" />))
        db.setWelcome()
    }
}

export const splashLoadingAction = () => async (dispatch) => {
    setTimeout( () => {
        dispatch(backdropAction(false))
    } , config.splashTime)
}